// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3I-ZI","bigColWidth":"Table_bigColWidth__3L7oG","biggerColWidth":"Table_biggerColWidth__1jJFt","row":"Table_row__sdlyU","col":"Table_col__3l-4u"};